export default __webpack_public_path__ + "static/media/liberty-home-guard.199d2419.png";